// External Dependences
import { DateTime } from 'luxon-business-days';
import { Calendar } from 'fullcalendar';
import dayGridPlugin from '@fullcalendar/daygrid';
import luxonPlugin from '@fullcalendar/luxon3';
import { store, getContext, getElement, useState, useEffect } from "@wordpress/interactivity";

const { state, callbacks, actions } = store('frs-blocks/date-selector', {
  callbacks: {
    initialize: function(e){
      const context = getContext();
      const calendar_element = document.querySelector('[data-date-picker-instance="' + context.instance_id + '"] .calendar');

      if(calendar_element){
        var current_date = DateTime.fromObject({ hour: 0 });
        var first_available_day = current_date.set({ hour: 0, minute: 0 }).plusBusiness({ days: 3 });
        var last_available_day = current_date.set({ hour: 0, minute: 0 }).plusBusiness({ days: 90 });
        var excluded_dates = [];
        var associated_flow_data = false;
        var related_form = false;

        calendar_element.setAttribute('data-validate', 'true');

        if(context.associated_flow){
          associated_flow_data = store('frs-blocks/popup');

          related_form = document.querySelector('[data-flow-id="' + context.associated_flow + '"] .wp-block-frs-blocks-form-embed');

          if(typeof associated_flow_data['state']['flows'] !== 'undefined' && typeof associated_flow_data['state']['flows'][context.associated_flow] !== 'undefined'){
            associated_flow_data['state']['flows'][context.associated_flow]['data']['date_selector_instance'] = context.instance_id;
          }
        }

        if(context.cutoff_date){
          last_available_day = DateTime.fromMillis(Date.parse(context.cutoff_date));
        }

        if(state.unavailable_dates){
          var individual_date_exclusions = state.unavailable_dates.split(',');
          var current_year = new Date().getFullYear();

          individual_date_exclusions.forEach(function(date, date_index){
            excluded_dates.push(date + '/' + current_year)
          });
        }

        if(last_available_day.invalid !== null){
          last_available_day = current_date.plus({ days: 90 });
        } else {
          last_available_day = last_available_day.plus({ days: 1 }).set({ hour: 0, minute: 0 });
        }

        var holiday_checker = DateTime.local();

        holiday_checker.setupBusiness({
          holidayMatchers: [
            holiday_checker.availableHolidayMatchers.isNewYearsDay,
            holiday_checker.availableHolidayMatchers.isMLKDay,
            holiday_checker.availableHolidayMatchers.isEasterDay,
            holiday_checker.availableHolidayMatchers.isMemorialDay,
            holiday_checker.availableHolidayMatchers.isIndependanceDay,
            holiday_checker.availableHolidayMatchers.isLaborDay,
            holiday_checker.availableHolidayMatchers.isColumbusDay,
            holiday_checker.availableHolidayMatchers.isThanksgivingDay,
            holiday_checker.availableHolidayMatchers.isChristmasDay
          ]
        });

        if(!context.calendar){
          context.calendar = new Calendar(calendar_element, {
            timeZone: 'America/Los_Angeles',
            fixedWeekCount: false,
            unselectAuto: false,
            height: '100%',
            expandRows: true,
            headerToolbar: {
              left: 'prev',
              center: 'title',
              right: 'next'
            },
            initialView: 'dayGridMonth',
            dayHeaders: false,
            editable: true,
            selectable: false,
            nowIndicator: true,
            dayMaxEvents: true,
            selectLongPressDelay: 0,
            datesSet: function(dateInfo){
              var days = calendar_element.querySelectorAll('.fc-daygrid-day');
              var last_day_on_grid = DateTime.fromISO(days[days.length - 1].getAttribute('data-date')).startOf('day');
              var starting_date = DateTime.fromISO(dateInfo.startStr);
              var ending_date = DateTime.fromISO(dateInfo.endStr);

              if(last_day_on_grid.diff(first_available_day.startOf('day'), 'days').toObject().days <= 0){
                if(!context.calendar_start_at_next_month){
                  context.calendar_start_at_next_month = true;
                }
              }

              if((starting_date.valueOf() < current_date.minus({ days: 8 }).valueOf())){
                calendar_element.querySelector('.fc-header-toolbar .fc-prev-button').classList.add('disabled');
              } else {
                calendar_element.querySelector('.fc-header-toolbar .fc-prev-button').classList.remove('disabled');
              }

              if((ending_date.valueOf() > last_available_day.valueOf())){
                calendar_element.querySelector('.fc-header-toolbar .fc-next-button').classList.add('disabled');
              } else {
                calendar_element.querySelector('.fc-header-toolbar .fc-next-button').classList.remove('disabled');
              }

              calendar_element.querySelectorAll('.fc-daygrid-day').forEach(function(element, element_index){
                var processing_date = DateTime.fromISO(element.getAttribute('data-date'));
                var first_available_day_matching_format = parseInt(first_available_day.toFormat('yyyyMMdd'));
                var last_available_day_matching_format = parseInt(last_available_day.toFormat('yyyyMMdd'));
                var day_matching_format = processing_date.toFormat('yyyyMMdd');
                var is_holiday = DateTime.fromISO(element.getAttribute('data-date')).isHoliday();
                var is_excluded_date = false;

                excluded_dates.forEach(function(excluded_date, excluded_date_index){
                  if(day_matching_format == DateTime.fromMillis(Date.parse(excluded_date)).set({ hour: 0, minute: 0 }).toFormat('yyyyMMdd')){
                    is_excluded_date = true;
                  }
                });

                if((day_matching_format <= first_available_day_matching_format) || (day_matching_format >= last_available_day_matching_format) || (is_holiday) || (is_excluded_date === true)){
                  element.classList.add('fc-day-disabled');
                }

                if(context.selectedDate){
                  context.calendar.select(context.selectedDate, false, true, null);
                }
              });

              if(calendar_element.querySelectorAll('.fc-daygrid-day:not(.fc-day-disabled):not(.fc-day-sat):not(.fc-day-sun)').length < 1){
                if(!context.calendar_start_at_next_month){
                  context.calendar_start_at_next_month = true;
                }
              }

              if(context.calendar_start_at_next_month){
                context.calendar.next();
                context.calendar_start_at_next_month = false;
              }
            },

            dateClick: function(selection){
              var selected_date = DateTime.fromISO(selection.dateStr);
              var current_date = DateTime.now();
              var is_excluded_date = false;

              excluded_dates.forEach(function(excluded_date, excluded_date_index){
                if(selected_date.valueOf() == DateTime.fromMillis(Date.parse(excluded_date.replace('YYYY', selected_date.toFormat('yyyy')))).set({ hour: 0, minute: 0 }).valueOf()){
                  is_excluded_date = true;
                }
              });

              if((selected_date.valueOf() <= first_available_day.valueOf()) || (selected_date.valueOf() >= last_available_day.valueOf()) || selected_date.weekday == 6 || selected_date.weekday == 7 || selected_date.isHoliday() || (is_excluded_date === true)){
                context.selected_date = false;
                context.calendar.unselect();
              } else {
                var selected_date_day_ordinal = '';
                var selected_date_day = selected_date.toFormat('d');
                var selected_date_month = selected_date.toFormat('LLLL');
                var selected_date_year = selected_date.toFormat('yyyy');
                var day_ordinal_matcher = 10;

                if((selected_date_day.length > 1 && selected_date_day.slice(0, 1) != 1) || selected_date_day.length < 2){
                  day_ordinal_matcher = selected_date_day.slice(-1);
                }

                day_ordinal_matcher = day_ordinal_matcher.toString();

                switch(day_ordinal_matcher){
                  case '1':
                    selected_date_day_ordinal = 'st';
                  break;

                  case '2':
                    selected_date_day_ordinal = 'nd';
                  break;

                  case '3':
                    selected_date_day_ordinal = 'rd';
                  break;

                  default:
                    selected_date_day_ordinal = 'th';
                  break;
                }

                var selected_date_string = selected_date_month + ' ' + selected_date_day + selected_date_day_ordinal + ' ' + selected_date_year;

                context.calendar.select(selection.dateStr, false, true, null);
                context.selected_date = selected_date_string;
              }

              callbacks.validate(context, true);

              if(associated_flow_data){
                if(typeof associated_flow_data['state']['flows'] !== 'undefined' && typeof associated_flow_data['state']['flows'][context.associated_flow] !== 'undefined'){
                  associated_flow_data['state']['flows'][context.associated_flow]['data']['selected_date'] = context.selected_date;;
                }

                if(related_form){
                  var form_id = related_form.getAttribute('data-form');
                  var form_instance = MktoForms2.getForm(form_id);

                  form_instance.setValues({
                    'cPECourseDay': context.selected_date
                  });
                }
              }
            }
          });
        }

        if(context.calendar !== false){
          context.calendar.render();
        }

        calendar_element.addEventListener('validate', function(e){
          callbacks.validate(context)
        });
      }
    },

    validate: function(context, hide_message){
      var calendar_element = document.querySelector('[data-date-picker-instance="' + context.instance_id + '"]');

      calendar_element.removeAttribute('data-invalid');

      if(calendar_element.querySelector('.error-message')){
        calendar_element.querySelector('.error-message').remove();
      }

      if((!context.selected_date) && (!hide_message)){
        calendar_element.setAttribute('data-invalid', 'true');

        if(!calendar_element.querySelector('.error-message')){
          calendar_element.insertAdjacentHTML('beforeend', '<div class="error-message" tabindex="-1" role="alert" aria-live="assertive">You must select a date in order to continue.</div>');
        }
      }
    }
  }
});
